import { FC, PropsWithChildren } from 'react';
import type { ApiError } from 'utils/http/apiErrorHelper';

import { CancelButton, RequestButton } from './buttons';
import { ErrorFeedback } from './errorFeedback/ErrorFeedback';
import { Spacer } from './spacer';

export const PostCreationActions: FC<
  PropsWithChildren<{
    cancellationError?: ApiError;
    onCancelled: () => void;
    onDimissCancellationError: () => void;
  }>
> = ({ cancellationError, onCancelled, onDimissCancellationError }) => (
  <>
    {cancellationError ? (
      <ErrorFeedback
        errorType="cancellation"
        error={cancellationError}
        className="flex-grow-1"
        onDimiss={onDimissCancellationError}
      />
    ) : (
      <CancelButton onCancel={onCancelled} className="flex-grow-1" />
    )}
    <Spacer />
    <RequestButton className="flex-grow-1" />
  </>
);
